import { createFileRoute } from "@tanstack/react-router";
import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";
import { useSuspenseGraphQL } from "@/hooks/use-graphql";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderUpButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { PersonalizeAppointmentForm } from "@/components/assist/secretary-details/personalize-appointment-form";
import { AssistFeatures } from "@/enums/assist-features";
import { validateFeatureAccess } from "@/lib/assist-feature-guard";

import type { JSX } from "react";

// biome-ignore lint/plugin/route-file-exports: predates the rule; move it out
export const GetSecretaryDetailsPageQuery = graphql(/* GraphQL */ `
  query GetSecretaryDetailsPageQuery {
    ...PersonalizeAppointmentFormFragment
  }
`);

const SecretaryDetailsPage = (): JSX.Element => {
  const { data } = useSuspenseGraphQL(GetSecretaryDetailsPageQuery, {});

  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="" align="center" />
      </HeaderRoot>
      <Page>
        <PersonalizeAppointmentForm data={data} />
      </Page>
    </>
  );
};
export const Route = createFileRoute("/settings/assist/secretary-details/")({
  component: SecretaryDetailsPage,
  pendingComponent: () => <PendingComponent title="" />,
  beforeLoad: ({ context, location }) => {
    const user = context.user;
    validateFeatureAccess({
      location,
      user,
      codFuncionalidade: AssistFeatures.PersonalizeAppointment,
    });
  },
});
